import { useState, useEffect } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Input,
    List,
    Button,
    Fab,
    IconButton
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

const BulkRow = ({ report, onSend, initialData, autoFill }) => {
    const [comentario, setComentario] = useState(initialData.comentario || '')
    const [operarios, setOperarios] = useState(initialData.operarios || 0)
    const [showConfirm, setShowConfirm] = useState(false)
    const [sent, setSent] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        if (autoFill && !sent) {
            setComentario(autoFill.comentario)
            setOperarios(autoFill.operarios)
        }
    }, [autoFill, sent])

    const handlePrepareSend = () => {
        if (!comentario || Number(operarios) <= 0) {
            setError(
                'Complete la descripción y cantidad de operadores antes de enviar.'
            )
            return
        }
        setError('')
        setShowConfirm(true)
    }

    const handleConfirm = () => {
        onSend({ comentario, operarios: Number(operarios) })
        setSent(true)
        setShowConfirm(false)
    }

    const handleCancel = () => {
        setShowConfirm(false)
    }

    if (sent) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2,
                    mb: 2,
                    border: '2px solid #4caf50',
                    borderRadius: 1,
                    bgcolor: '#e8f5e9'
                }}
            >
                <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#4caf50' }} />
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
					OT {report.newIdIndex || report.idIndex} - Jornada terminada
					correctamente
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            sx={{
                display: 'flex',
                gap: 2,
                mb: 2,
                position: 'relative',
                minHeight: 'auto'
            }}
        >
            {/* OBJETO 1: FORMULARIO LINEAL */}
            <Box
                sx={{
                    bgcolor: 'white',
                    border: '2px solid black',
                    p: 2,
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 3,
                    transition: 'all 0.3s ease'
                }}
            >
                <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: 4, flexGrow: 1 }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            sx={{
                                fontSize: 10,
                                fontWeight: 900,
                                color: 'gray',
                                textTransform: 'uppercase'
                            }}
                        >
							ot:
                        </Typography>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14, width: 80 }}>
                            {report.newIdIndex || report.idIndex}
                        </Typography>
                    </Box>
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}
                    >
                        <Typography
                            sx={{
                                fontSize: 10,
                                fontWeight: 900,
                                color: 'gray',
                                textTransform: 'uppercase'
                            }}
                        >
							descripción:
                        </Typography>
                        <Input
                            fullWidth
                            placeholder="Detalle de la tarea..."
                            value={comentario}
                            onChange={(e) => setComentario(e.target.value)}
                            sx={{ fontSize: 13 }}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            sx={{
                                fontSize: 10,
                                fontWeight: 900,
                                color: 'gray',
                                textTransform: 'uppercase'
                            }}
                        >
							nro operarios:
                        </Typography>
                        <Input
                            type="number"
                            sx={{ width: 50, fontSize: 13 }}
                            value={operarios}
                            onChange={(e) => setOperarios(e.target.value)}
                        />
                    </Box>
                </Box>
                <Button
                    variant="contained"
                    onClick={handlePrepareSend}
                    sx={{
                        bgcolor: '#663c00',
                        color: 'white',
                        fontWeight: 900,
                        fontSize: 10,
                        px: 3,
                        '&:hover': { bgcolor: '#ab0a0a' }
                    }}
                >
					enviar
                </Button>
            </Box>
            {error && (
                <Typography
                    variant="caption"
                    sx={{
                        color: 'red',
                        fontWeight: 'bold',
                        mt: 1,
                        position: 'absolute',
                        bottom: -20,
                        left: 0
                    }}
                >
                    {error}
                </Typography>
            )}

            {/* OBJETO 2: CONFIRMACIÓN LATERAL */}
            {showConfirm && (
                <Box
                    className="slide-in"
                    sx={{
                        bgcolor: 'white',
                        border: '2px solid black',
                        p: 2,
                        width: '350px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        animation: 'slideIn 0.4s ease-out forwards',
                        '@keyframes slideIn': {
                            from: { opacity: 0, transform: 'translateX(30px)' },
                            to: { opacity: 1, transform: 'translateX(0)' }
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            style={{
                                backgroundColor: '#e8f5e9',
                                borderRadius: '50%',
                                padding: 5,
                                marginRight: 10,
                                display: 'flex'
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faCheckCircle}
                                style={{ color: '#4caf50' }}
                            />
                        </div>
                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: 900,
                                textTransform: 'uppercase',
                                fontStyle: 'italic'
                            }}
                        >
							Confirmar
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 3 }}>
                        <Button
                            onClick={handleConfirm}
                            sx={{
                                minWidth: 'auto',
                                fontWeight: 900,
                                fontSize: 18,
                                borderRadius: 5,
                                fontStyle: 'italic',
                                color: 'black',
                                '&:hover': { color: '#4caf50' }
                            }}
                        >
							SI
                        </Button>
                        <Button
                            onClick={handleCancel}
                            sx={{
                                minWidth: 'auto',
                                fontWeight: 900,
                                fontSize: 18,
                                fontStyle: 'italic',
                                color: 'black',
                                borderRadius: 5,
                                '&:hover': { color: '#f44336' }
                            }}
                        >
							NO
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    )
}

const BulkFinishShiftDialog = ({
    open,
    reports,
    onClose,
    onFinishReport,
    andLogout
}) => {
    const [lastSentData, setLastSentData] = useState(null)
    const [reportsState, setReportsState] = useState([])

    useEffect(() => {
        if (reports && open) {
            setReportsState(reports.map((r) => ({ ...r, sent: false })))
        }
    }, [reports, open])

    const handleSend = (reportId, data) => {
        onFinishReport(reportId, data)
        setLastSentData(data)
        setReportsState((prev) =>
            prev.map((r) => (r._id === reportId ? { ...r, sent: true } : r))
        )
    }

    const allSent = reportsState.length > 0 && reportsState.every((r) => r.sent)

    useEffect(() => {
        if (allSent && open) {
            setTimeout(() => {
                onClose(true)
            }, 1500)
        }
    }, [allSent, onClose, open])

    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            maxWidth="lg"
            fullWidth
            PaperProps={{ sx: { bgcolor: '#f5f5f5', p: 2, borderRadius: 5 } }}
        >
            <DialogTitle
                sx={{
                    fontWeight: 900,
                    textTransform: 'uppercase',
                    letterSpacing: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h5" sx={{ fontWeight: 900 }}>
					Pautas abiertas encontradas (
                    {reportsState.filter((r) => !r.sent).length})
                </Typography>
                <IconButton onClick={() => onClose(false)}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography
                    variant="body2"
                    sx={{
                        mb: 4,
                        color: '#666',
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }}
                >
					Debe cerrar todas las pautas antes de{' '}
                    {andLogout ? 'cerrar sesión' : 'continuar'}.
                </Typography>
                <List sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {reportsState.map((report) => (
                        <BulkRow
                            key={report._id}
                            report={report}
                            onSend={(data) => handleSend(report._id, data)}
                            initialData={{ comentario: '', operarios: 0 }}
                            autoFill={lastSentData}
                        />
                    ))}
                </List>
            </DialogContent>
        </Dialog>
    )
}

export default BulkFinishShiftDialog
